import '@/features/Logos/FanDuel/styles/index.scss';

const FanduelLogo = () => {
  return (
    <div className="fanduel-logo">
      <div id="moving-parts">
        <svg
          id={'bell'}
          data-testid="fd-moving-bell"
          width={68}
          height={68}
          fill="none"
          viewBox="0 -6 68 68"
        >
          <mask
            id="1"
            width={68}
            height={68}
            x={0}
            y={0}
            maskUnits="userSpaceOnUse"
            style={{
              maskType: 'alpha',
            }}
          >
            <path fill="#D9D9D9" d="M0 0h68v55H0z" />
          </mask>
          <g mask="url(#1)">
            <path
              stroke="#fff"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={4.5}
              d="M25.75 43.094c0 10.312 15.469 10.312 15.469 0M33.484 7c-8.483 0-14.609 5.156-14.609 12.031v10.313L12 41.375h42.969l-6.875-12.031V19.03C48.094 12.156 44.086 7 33.484 7Z"
            />
          </g>
        </svg>
        <svg
          id={'cherry'}
          data-testid="fd-moving-cherry"
          width={55}
          height={55}
          fill="none"
          viewBox="7 -2 55 55"
        >
          <mask
            id="2"
            width={55}
            height={55}
            x={0}
            y={0}
            maskUnits="userSpaceOnUse"
            style={{
              maskType: 'alpha',
            }}
          >
            <path fill="#D9D9D9" d="M0 0h68v55H0z" />
          </mask>
          <g
            stroke="#fff"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={4}
            mask="url(#2)"
          >
            <path d="M16.167 34.812a8.02 8.02 0 1 0 16.041 0 8.02 8.02 0 0 0-16.041 0Zm22.916 3.438a6.875 6.875 0 1 0 13.75 0 6.875 6.875 0 0 0-13.75 0Z" />
            <path d="M27.625 26.792c.839-4.584 4.276-8.876 10.313-12.834m8.02 17.417c-3.054-5.346-5.346-12.221-2.291-20.625" />
            <path d="M18.459 10.75c8.403-6.112 16.804-6.112 25.208 0-8.404 6.112-16.805 6.112-25.209 0Z" />
          </g>
        </svg>
        <svg
          id={'fd-logo'}
          data-testid="fd-moving-logo"
          width={68}
          height={68}
          viewBox="5 0 68 68"
        >
          <mask
            id="3"
            width={68}
            height={68}
            x={0}
            y={0}
            maskUnits="userSpaceOnUse"
            style={{
              maskType: 'alpha',
            }}
          >
            <rect x="0" y="0" width="68" height="68" fill="#D9D9D9" />
          </mask>
          <g mask="url(#3)">
            <path
              fill="#fff"
              d="M22.833 25.12c3.651-1.704 7.499-2.74 11.281-3.192.412-.056.58.226.534.556a73.54 73.54 0 0 0-.927 8.88c-.028.338-.215.564-.59.64-2.097.414-4.147 1.064-6.403 2.1 2.031 3.55 4.484 6.798 7.19 9.52.308.329.496.668.58 1.223.702 4.558 1.928 9.153 3.567 13.503.103.245.103.415-.047.556-.16.141-.393.141-.618 0C21.045 48.878 11.169 30.902 11 12.06c0-.452.16-.79.534-1.007 8.687-4.897 18.46-7.25 28.272-7.044.44.02.59.396.421.754a62.61 62.61 0 0 0-3.37 8.578c-.103.339-.309.508-.674.527a45.15 45.15 0 0 0-15.035 3.418 48.324 48.324 0 0 0 1.676 7.834h.01Zm18.115-11.224c-.328-.028-.552-.33-.45-.65 1.03-3.003 2.21-5.847 3.558-8.483.16-.311.421-.443.787-.396a54.694 54.694 0 0 1 20.614 6.676c.384.217.552.556.534 1.008-.131 17.843-9.016 34.924-23.976 45.245-.28.197-.646.084-.777-.245-1.086-2.938-1.975-5.913-2.612-8.795-.084-.386 0-.678.3-.904 9.053-7.175 15.4-17.881 16.926-30.066a45.07 45.07 0 0 0-14.904-3.39Z"
            />
          </g>
        </svg>
      </div>
      <svg
        width="154"
        height="64"
        viewBox="70 0 154 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M79.1307 9.34948C79.1307 9.13035 79.2826 8.97696 79.4997 8.97696H96.064C96.2594 8.97696 96.433 9.19609 96.3462 9.3933L94.8483 13.5348C94.7614 13.7759 94.6095 13.8635 94.3489 13.8635H84.2324V18.3337H92.6773C92.8727 18.3337 93.0464 18.5529 92.9595 18.7501L91.505 22.8039C91.4182 23.045 91.2662 23.1545 91.0057 23.1545H84.2324V30.6706C84.2324 30.8898 84.0804 31.0431 83.8633 31.0431H79.478C79.2609 31.0431 79.109 30.8898 79.109 30.6706V9.32757L79.1307 9.34948ZM101.361 9.32757C101.448 9.08652 101.6 8.99887 101.86 8.99887H107.722C107.961 8.99887 108.134 9.10844 108.221 9.32757L115.885 30.6706C115.95 30.8678 115.798 31.087 115.602 31.087H110.957C110.718 31.087 110.566 30.9774 110.479 30.7364L109.003 26.4415H100.514L99.0382 30.7364C98.973 30.9774 98.7994 31.087 98.5605 31.087H93.9799C93.7845 31.087 93.6108 30.8678 93.6977 30.6706L101.361 9.32757ZM107.375 21.5987L104.769 13.9731L102.164 21.5987H107.396H107.375ZM118.034 9.34948C118.034 9.13035 118.186 8.97696 118.403 8.97696H123.505C123.765 8.97696 123.917 9.06461 124.069 9.30565L131.689 22.3876V9.34948C131.689 9.13035 131.841 8.97696 132.058 8.97696H136.357C136.574 8.97696 136.726 9.13035 136.726 9.34948V30.6925C136.726 30.9117 136.574 31.0651 136.357 31.0651H131.32C131.059 31.0651 130.907 30.9774 130.756 30.7364L123.092 17.5668V30.6925C123.092 30.9117 122.94 31.0651 122.723 31.0651H118.425C118.208 31.0651 118.056 30.9117 118.056 30.6925V9.34948H118.034ZM149.143 26.1785C152.617 26.1785 155.244 23.5271 155.244 20.021C155.244 16.515 152.617 13.8635 149.143 13.8635H141.371C141.154 13.8635 141.002 13.7101 141.002 13.491V9.32757C141.002 9.10844 141.154 8.95505 141.371 8.95505H149.143C155.548 8.95505 160.345 13.6882 160.345 19.9991C160.345 26.31 155.548 31.0431 149.143 31.0431H141.371C141.154 31.0431 141.002 30.8898 141.002 30.6706V20.3497C141.002 18.9692 141.437 17.8955 142.218 17.1066C142.913 16.4054 144.02 15.9233 144.997 15.9233H145.757C145.974 15.9233 146.126 16.0767 146.126 16.2958V26.1566H149.165L149.143 26.1785ZM163.493 22.3438V9.34948C163.493 9.13035 163.645 8.97696 163.862 8.97696H168.248C168.465 8.97696 168.617 9.13035 168.617 9.34948V22.3438C168.617 24.8418 170.353 26.5948 172.828 26.5948C175.303 26.5948 177.04 24.8637 177.04 22.3438V9.34948C177.04 9.13035 177.192 8.97696 177.409 8.97696H181.794C182.011 8.97696 182.163 9.13035 182.163 9.34948V22.3438C182.163 27.7562 178.364 31.4814 172.85 31.4814C167.336 31.4814 163.537 27.7781 163.537 22.3438H163.493ZM201.224 17.523C201.441 17.523 201.593 17.6763 201.593 17.8955V21.9932C201.593 22.2123 201.441 22.3657 201.224 22.3657H191.542V26.2004H201.789C202.006 26.2004 202.158 26.3538 202.158 26.5729V30.7364C202.158 30.9555 202.006 31.1089 201.789 31.1089H186.787C186.57 31.1089 186.418 30.9555 186.418 30.7364V9.3933C186.418 9.17417 186.57 9.02078 186.787 9.02078H201.789C202.006 9.02078 202.158 9.17417 202.158 9.3933V13.5567C202.158 13.7759 202.006 13.9293 201.789 13.9293H191.542V17.5887H201.224V17.523ZM211.558 26.1785H221.631C221.848 26.1785 222 26.3319 222 26.551V30.7145C222 30.9336 221.848 31.087 221.631 31.087H206.803C206.586 31.087 206.434 30.9336 206.434 30.7145V9.37139C206.434 9.15226 206.586 8.99887 206.803 8.99887H211.189C211.406 8.99887 211.558 9.15226 211.558 9.37139V26.2004V26.1785ZM86.273 38.4935C90.0722 38.4935 93.0898 40.8163 94.1318 44.2566H91.2879C90.4195 42.3063 88.5742 41.0573 86.2513 41.0573C82.8864 41.0573 80.4767 43.6211 80.4767 47.0833C80.4767 50.5455 82.8864 53.0874 86.2513 53.0874C88.5742 53.0874 90.4195 51.8384 91.2879 49.8882H94.1318C93.0898 53.3066 90.0722 55.6293 86.273 55.6293C81.3884 55.6293 77.8064 51.9699 77.8064 47.0614C77.8064 42.1529 81.3884 38.4935 86.273 38.4935ZM99.2553 50.8961L97.5836 55.3444H94.7614L101.122 38.7784H104.509L110.848 55.3444H108.026L106.354 50.8961H99.2118H99.2553ZM102.816 41.4298L100.21 48.3762H105.421L102.816 41.4298ZM118.685 55.6293C114.083 55.6293 112.064 53.0874 111.63 50.2168H114.3C114.799 52.1233 116.058 53.1313 118.663 53.1313C120.878 53.1313 122.137 52.2547 122.137 50.7208C122.137 49.187 120.791 48.924 117.752 48.2447C114.56 47.5216 112.064 46.6231 112.064 43.5334C112.064 40.2465 114.951 38.5154 118.099 38.5154C122.224 38.5154 124.134 40.6629 124.59 43.2924H121.92C121.442 41.9338 120.335 41.0135 118.121 41.0135C115.906 41.0135 114.712 41.9995 114.712 43.4458C114.712 44.6291 115.646 45.0016 118.381 45.5933C122.528 46.5136 124.807 47.3901 124.807 50.5894C124.807 54.205 121.616 55.6293 118.685 55.6293ZM130.625 38.7784V55.3444H127.977V38.7784H130.625ZM148.297 55.3444H145.171L137.16 42.8542V55.3444H134.555V38.7784H137.681L145.692 51.2687V38.7784H148.297V55.3444ZM160.085 55.6293C155.265 55.6293 151.575 51.948 151.575 47.0614C151.575 42.1749 155.265 38.4935 160.085 38.4935C164.904 38.4935 168.573 42.1749 168.595 47.0614C168.552 51.926 164.883 55.6293 160.085 55.6293ZM160.085 53.0874C163.385 53.0874 165.903 50.5455 165.903 47.0833C165.903 43.6211 163.406 41.0573 160.085 41.0573C156.763 41.0573 154.245 43.6211 154.245 47.0833C154.245 50.5455 156.742 53.0874 160.085 53.0874Z"
          fill="white"
        />
      </svg>
    </div>
  );
};

export default FanduelLogo;
